<template>
  <div class="inquiryticket">
    <div v-if="!(isReservedChange || isPurchasedChange)" class="accept-terms">
      <input class="checkbox" type="checkbox" id="accept-terms" @click="checkRegulation" />
      <label class="checkbox" for="accept-terms">利用規約に同意</label>
    </div>

    <div style="width: 100%">
      <ItemButton label="空席照会へ" :isDisabled="isDisabled" :actionType="actionType" @clicked="onPressedVacancyInquiry" />
    </div>
  </div>

  <!-- 購入後の予約変更時(1回目)の確認ダイアログ -->
  <DialogConfirmFirstTimeToChangePurchasedTicket ref="DialogConfirmFirstTimeToChangePurchasedTicket"
    @goToNextPage="goToNextPage" />

  <!-- 購入後の予約変更時(2回目)のエラーダイアログ -->
  <DialogCanNotChangePurchasedTicket ref="DialogCanNotChangePurchasedTicket" />

  <!-- ローディングダイアログ -->
  <DialogLoading ref="DialogLoading" :timeoutSeconds="21000" />

  <!-- 非対応の区間を選択した場合 -->
  <DialogInvalidSection ref="DialogInvalidSection" />

  <!-- 引換券使用時、非対応の区間を選択した場合 -->
  <DialogInvalidSectionWithCoupon ref="DialogInvalidSectionWithCoupon" />

  <DialogNotExitTrain ref="DialogNotExitTrain" />

  <!-- 電波状況が悪い場合のダイアログ　-->
  <DialogBadReception ref="DialogBadReception" />

  <DialogDuringMaintenance ref="DialogDuringMaintenance" />

  <DialogNotSpecifyEBINA ref="DialogNotSpecifyEBINA" />

  <DialogUnexpectedError ref="DialogUnexpectedError" />
</template>

<script>
import { onMounted, watchEffect, ref } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";

import moment from "@/services/moment";

import API from "@/API";

import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "MFITTBookingBottomButton",
  props: {
    // 予約変更(購入前)の場合true
    isReservedChange: {
      type: Boolean,
      required: false,
      default: false,
    },
    // チケット内容変更(購入後)の場合true
    isPurchasedChange: {
      type: Boolean,
      required: false,
      default: false,
    },
    // サルーン席の場合は、人数の表記が異なるのでフラグを保持しておく
    isSaloon: {
      type: Boolean,
      required: false,
      default: false,
    },
    // 変更前の乗車日(購入の変更時使用)
    beforeBoardingDate: {
      type: String,
      required: false,
      default: "",
    },
    // すでに一度日付を変更しているかどうか(購入の変更時使用)
    hasChangedBoardingDate: {
      type: Boolean,
      required: false,
      default: false,
    },
    boardingDate: {
      type: String,
      required: true,
    },
    searchDivision: {
      type: Number,
      required: true,
    },
    time: {
      type: String,
      required: true,
    },
    fromStation: {
      type: Object,
      required: true,
    },
    toStation: {
      type: Object,
      required: true,
    },
    secondFromStation: {
      type: Object,
      required: false,
      default: null,
    },
    secondToStation: {
      type: Object,
      required: false,
      default: null,
    },
    adultCount: {
      type: Number,
      required: true,
    },
    childCount: {
      type: Number,
      required: true,
    },
    isCompleteInput: {
      type: Boolean,
      required: true,
    },
  },
  setup(props) {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();

    const DialogLoading = ref(null);
    const DialogInvalidSection = ref(null);
    const DialogInvalidSectionWithCoupon = ref(null);
    const DialogNotExitTrain = ref(null);
    const DialogBadReception = ref(null);
    const DialogUnexpectedError = ref(null);
    const DialogDuringMaintenance = ref(null);
    const DialogConfirmFirstTimeToChangePurchasedTicket = ref(null);
    const DialogCanNotChangePurchasedTicket = ref(null);
    const DialogNotSpecifyEBINA = ref(null);

    const actionType = ref("disabled");
    const isChecked = ref(false);
    const isDisabled = ref(true);
    const isChange = route.path.split("/")[4] === "change";

    const checkRegulation = () => {
      var ele = document.getElementsByClassName("checkbox")[0];
      isChecked.value = ele.checked;
    };

    const onPressedVacancyInquiry = async () => {
      // 購入後の変更時のみ、日付を変更していればダイアログ表示
      if (
        props.isPurchasedChange &&
        moment(new Date(props.beforeBoardingDate)).format("YYYYMMDD") !=
        moment(new Date(props.boardingDate)).format("YYYYMMDD")
      ) {
        // すでに日付変更したことがあれば、日付変更不可のエラーダイアログ
        if (props.hasChangedBoardingDate) {
          DialogCanNotChangePurchasedTicket.value.openDialog();
          // 初めての日付変更の場合は、確認のダイアログ
        } else {
          DialogConfirmFirstTimeToChangePurchasedTicket.value.openDialog();
        }
      } else {
        goToNextPage();
      }
    };

    const goToNextPage = async () => {
      // ローディングダイアログ
      DialogLoading.value.openDialog();
      // フロントでの入力内容を格納
      setInputtedInfoOnBooking();
      // 空席照会時刻指定API
      try {
        //列車変更の場合はチケットIDをパラメータに付与する。
        if (isChange) {
          await API.getVacancyInquiry(0, "", route.params.id);
        } else {
          await API.getVacancyInquiry();
        }
        // 次ページへ
        goToBooking2();
      } catch (e) {
        // 電波がない場合、e.response.data.messageが存在しない
        // loadingを表示し続け、そちらでタイムアウトさせる
        if (e.response.data.message) {
          DialogLoading.value.closeDialog();
          // 非対応の区間を指定した場合
          if (
            e.response.data.message ===
            "section指定された区間（乗車駅、降車駅）は、誤っています"
          ) {
            DialogInvalidSection.value.openDialog();
          } else if (e.response.data.error === "departed") {
            DialogNotExitTrain.value.openDialog();
          } else if (e.response.data.error === "price_error") {
            DialogInvalidSectionWithCoupon.value.openDialog();
          } else if (e.response.data.message === "回線が込み合っています") {
            DialogBadReception.value.openDialog();
            // MWのメンテナンス中
          } else if (e.response.status == 503) {
            DialogDuringMaintenance.value.openDialog(e.response.data);
            // token切れ。一時的な対応
          } else if (
            e.response.data.message === "ユーザー情報取得に失敗しました。"
          ) {
            nativeHandlerService.returnNativeAppToAccountPage();
          } else if (e.response.data.error === "must_specify_ebina") {
            DialogNotSpecifyEBINA.value.openDialog();
          } else {
            // nativeにエラー内容送信
            nativeHandlerService.ncSendMfittError(e.response.data.message);
            DialogUnexpectedError.value.openDialog();
          }
        } else {
          nativeHandlerService.ncSendMfittError(
            "MFITTBookingBottomButton goToNextPage()"
          );
        }
      }
    };

    // フロントでの入力内容を格納
    const setInputtedInfoOnBooking = () => {
      // localStorageに区間を保存
      // Objectとして扱うと反映されない場合があったので、idのみ
      localStorage.setItem("fromStationId", props.fromStation.id);
      localStorage.setItem("toStationId", props.toStation.id);

      // 出発到着駅のコードの比較で上り下りを判断する
      const bound = props.fromStation.code > props.toStation.code ? 0 : 1;

      const inputtedInfoOnBooking = {
        bound: bound,
        ticketId: route.params.id,
        isReservedChange: props.isReservedChange,
        isPurchasedChange: props.isPurchasedChange,
        isSaloon: props.isSaloon,
        boarding_date: props.boardingDate,
        search_division: props.searchDivision,
        time: props.time,
        from_station: props.fromStation,
        to_station: props.toStation,
        second_from_station: props.secondFromStation,
        second_to_station: props.secondToStation,
        adult_count: props.adultCount,
        child_count: props.childCount,
      };
      console.log("inputtedInfoOnBooking :>> ", inputtedInfoOnBooking);
      store.commit("MFITT/setInputtedInfoOnBooking", inputtedInfoOnBooking);
    };

    const goToBooking2 = () => {
      router.push({
        name: "MfittBooking2",
        query: {
          coupon_id: route.query.coupon_id,
          //列車変更の場合はチケットIDをパラメータに付与する。
          changing_limited_express_ticket_id: route.params.id,
        },
      });
    };

    onMounted(() => {
      // 予約変更の場合は規約同意のチェックはないので、フラグをtrueにしておく
      if (props.isReservedChange || props.isPurchasedChange) {
        isChecked.value = true;
      }
    });

    watchEffect(() => {
      // 規約同意にチェック、かつ必要な情報を全て入力済みでボタンenableに
      if (isChecked.value && props.isCompleteInput) {
        actionType.value = "btn-submit";
        isDisabled.value = false;
      } else {
        actionType.value = "disabled";
        isDisabled.value = true;
      }
    });

    return {
      actionType,
      isChecked,
      isDisabled,
      checkRegulation,
      goToNextPage,
      onPressedVacancyInquiry,
      DialogLoading,
      DialogInvalidSection,
      DialogInvalidSectionWithCoupon,
      DialogNotExitTrain,
      DialogBadReception,
      DialogUnexpectedError,
      DialogDuringMaintenance,
      DialogConfirmFirstTimeToChangePurchasedTicket,
      DialogCanNotChangePurchasedTicket,
      DialogNotSpecifyEBINA,
    };
  },
};
</script>
<style>
.inquiryticket {
  position: fixed;
  z-index: 990;
  left: 0;
  width: 100%;
  bottom: 0;
  background-color: #ffb206;
  padding: 15px 15px 20px 15px;
}

.inquiryticket .accept-terms {
  margin: 0 0 15px 0;
  text-align: center;
  font-size: 14px;
  font-weight: bold;
}

.inquiryticket button {
  width: calc(100% - 30px);
  height: 46px;
  border: none;
  border-radius: 30px;
  background-color: #ffffff;
  padding: 10px;
  font-size: 14px;
  font-weight: bold;
  color: #000000;
  box-shadow: var(--defaultBoxShadow);
}

.inquiryticket button:disabled {
  background-color: #e9e9e9;
  color: #999999;
}
</style>
